import PropTypes from 'prop-types'
import clsx from 'clsx'
import React from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import ResponsiveImage from 'components/images/responsive-image'
import { POMELO_STORES_LOCATION_DETAILS } from 'pages/offline/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import {
  getNearestBtsData,
  renderTrainStation,
  renderStoreAndMapImages,
} from '../utils'
import styles from '../style.scss'

const StoreDetails = ({ address, t }) => {
  const BtsMrtStation = getNearestBtsData(address.nearest_bts)
  const mainTitleClassNames = clsx('PUAC__main-title', Typo.subtitle1)

  const renderHours = (hours) => (
    <div className={clsx('PUAC__open-hours', Typo.body2)} key={hours}>
      {hours.split(' : ').map((hour) => (
        <span key={hour}>{hour}</span>
      ))}
    </div>
  )

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      {address?.hours?.length > 0 && (
        <div className="PUAC__hours-contact">
          <div className={mainTitleClassNames}>
            {hasLocizeTranslation(
              t,
              POMELO_STORES_LOCATION_DETAILS.keyOpeningHours,
              POMELO_STORES_LOCATION_DETAILS.textOpeningHours,
            )}
          </div>

          {address.hours.map(renderHours)}
        </div>
      )}
      <div className="PUAC__location-closest-station">
        <span className="PUAC__location">
          <span className={mainTitleClassNames}>
            {hasLocizeTranslation(
              t,
              POMELO_STORES_LOCATION_DETAILS.keyLocation,
              POMELO_STORES_LOCATION_DETAILS.textLocation,
            )}
          </span>
          <div className="PUAC__zoomed-map">
            <ResponsiveImage
              src={renderStoreAndMapImages(address, 'zoomedMapMain')}
              alt="Pomelo Map"
              imgRatio={0.625}
            />
          </div>
          {address?.address1 ||
            (address?.address2 && (
              <span className={Typo.body2}>
                {address.address1 || address.address2}
              </span>
            ))}
          {address?.latitude && address?.longitude && (
            <a
              href={`https://maps.google.com/maps?daddr=${address.latitude},${address.longitude}`}
              rel="noopener noreferrer"
              target="_blank"
              className={clsx('PUAC__get-direction', Typo.overline)}
            >
              {hasLocizeTranslation(
                t,
                POMELO_STORES_LOCATION_DETAILS.keyGetDirection,
                POMELO_STORES_LOCATION_DETAILS.textGetDirection,
              )}
            </a>
          )}
        </span>
        {BtsMrtStation && (
          <span className="PUAC__closest-station">
            <span className={mainTitleClassNames}>
              {hasLocizeTranslation(
                t,
                POMELO_STORES_LOCATION_DETAILS.keyClosestStation,
                POMELO_STORES_LOCATION_DETAILS.textClosestStation,
              )}
            </span>
            {BtsMrtStation.map((station) =>
              renderTrainStation('PUAC__station', station),
            )}
          </span>
        )}
      </div>
    </React.Fragment>
  )
}

StoreDetails.propTypes = {
  t: PropTypes.func.isRequired,
  address: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    hours: PropTypes.arrayOf(PropTypes.shape({})),
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    nearest_bts: PropTypes.string,
  }).isRequired,
}

export default withI18next()(StoreDetails)
